import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Properties for the Jira items creation command.
 *
 * @extends CommandProperties
 */
export interface JiraCreatedItemsCommandProperties extends CommandProperties {
	/**
	 * Mapping of invocationId to the created issue key
	 */
	invocationIdToCreatedIssueKey: Record<string, string>;
}

/**
 * A command sent by a bridge API client to indicate that Jira items have been created.
 *
 * @summary {@link CommandProperties.senderId} is notifying {@link CommandProperties.receiverId} that Jira items have been created with the specified content.
 */
export const JiraCreatedItemsCommand: CommandConstructor<
	JiraCreatedItemsCommandProperties,
	SerializableValue
> = createCommand<JiraCreatedItemsCommandProperties>('jira-created-items-command');
